import GrpcWebStreamParser from './grpcwebstreamparser.js';

export const parse = (response) => {
  // console.log('grpcwebreadablestream [response]:', response);

  const parser = new GrpcWebStreamParser();
  var byteSource = new Uint8Array(/** @type {!ArrayBuffer} */ (response));
  var messages = null;
  try {
    messages = parser.parse(byteSource);
  } catch (err) {
    console.error(err);
  }

  // console.log('grpcwebreadablestream [messages]:', messages);

  if (messages) {
    const result = {
      data: null,
      trailer: null,
    };

    var FrameType = GrpcWebStreamParser.FrameType;

    for (var i = 0; i < messages.length; i++) {
      if (FrameType.DATA in messages[i]) {
        var data = messages[i][FrameType.DATA];
        if (data) {
          result.data = data;
        }
      } else if (FrameType.TRAILER in messages[i]) {
        var trailer = messages[i][FrameType.TRAILER];
        if (trailer) {
          result.trailer = trailer;
        }
      }
    }

    return result;
  }
};

export const parseHttpHeaders = (uint8arr) => {
  const str = String.fromCharCode.apply(null, uint8arr);

  const chunks = str.trim().split('\r\n');
  const headers = new Headers();
  for (let i = 0; i < chunks.length; i++) {
    const pos = chunks[i].indexOf(':');
    headers.set(chunks[i].substring(0, pos).trim(), chunks[i].substring(pos + 1).trim());
  }
  return headers;
};
